import axios from "axios"
import { addOrder, servicesInfo } from "../../../../../../config/api"
import { Dispatch } from "redux"
import { ActionType } from "./ActionTypes"
import { actionFetchUser } from "../../../../Actions/ActionCreator"

function fetchServiceInfo(serviceId : number) {
    return axios.get(servicesInfo.replace(':serviceId' , serviceId.toString()))
}

function fetchOrderInfo(infoId : number) {
    return axios.get(addOrder.replace(':infoId' , infoId.toString()))
}


export const actionFetchServiceInfo = (serviceId : number) => {
    
    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.SERVICE_INFO_LOADING })
        fetchServiceInfo(serviceId).then((res) => {
            
            dispatch({ type: ActionType.SERVICE_INFO_DATA, list: res.data.data })
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.SERVICE_INFO_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.SERVICE_INFO_ERROR, message: err.response.data.error })
            }
        })
    }
}

export const actionAddOrder = (infoId : number) => {
    
    return (dispatch: Dispatch) => {
        dispatch({ type: ActionType.SERVICE_ADD_ORDER_LOADING })
        fetchOrderInfo(infoId).then((res) => {
            
            dispatch({ type: ActionType.SERVICE_ADD_ORDER_DONE })
            dispatch(actionFetchUser() as any)
        }).catch(err => {
            if (err.code === 'ERR_NETWORK') {
                dispatch({ type: ActionType.SERVICE_ADD_ORDER_ERROR, message: 'ERR_NETWORK' })
            } else {
                dispatch({ type: ActionType.SERVICE_ADD_ORDER_ERROR, message: err.response.data.error })
            }
        })
    }
}